import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DeclarationHero } from '../components/accessibility/declaration/DeclarationHero';
import { BasicInfo } from '../components/accessibility/declaration/BasicInfo';
import { ComplianceStatus } from '../components/accessibility/declaration/ComplianceStatus';
import { AccessibilityFeatures } from '../components/accessibility/declaration/AccessibilityFeatures';
import { KeyboardShortcuts } from '../components/accessibility/declaration/KeyboardShortcuts';
import { ContactInfo } from '../components/accessibility/declaration/ContactInfo';
import { ArchitecturalAccessibility } from '../components/accessibility/declaration/ArchitecturalAccessibility';
import { DeclarationInfo } from '../components/accessibility/declaration/DeclarationInfo';
import { ContactCTA } from '../components/accessibility/declaration/ContactCTA';
import { ETRSection } from '../components/accessibility/declaration/ETRSection';
import { SignLanguageVideo } from '../components/accessibility/declaration/SignLanguageVideo';

export function AccessibilityDeclarationPage() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 py-16">
      <Helmet>
        <title>Deklaracja dostępności | Fundacja "Znajdki"</title>
        <meta name="description" content="Deklaracja dostępności strony internetowej Fundacji Znajdki. Informacje o dostępności cyfrowej naszej witryny." />
      </Helmet>

      <DeclarationHero />

      <div className="space-y-8">
        <BasicInfo />
        <SignLanguageVideo />
        <ETRSection />
        <ComplianceStatus />
        <AccessibilityFeatures />
        <KeyboardShortcuts />
        <ContactInfo />
        <ArchitecturalAccessibility />
        <DeclarationInfo />
        <ContactCTA />
      </div>
    </div>
  );
}